import styled from 'styled-components';

export const Wrapper = styled.div`
  background: var(--white);
  height: 100%;
  width: 100%;
  opacity: 0.7;
  z-index: 1;
`;
